import { staffText } from "@/lib/staff-language";

// Literal entries from the approved prototype's Arabic dictionary. Keep these
// here until the shared prototype fragments include the attendance additions.
const approved: Record<string, string> = {
  "Branches · this day": "الفروع · هذا اليوم",
  "The team that day": "الفريق في هذا اليوم",
  "Today's team": "فريق اليوم",
  "Why? (optional)": "السبب؟ (اختياري)",
  "from opening to closing": "من الافتتاح إلى الإغلاق",
  "Working": "شغال",
  "✓ Everyone's working · Save": "✓ الجميع يعملون · حفظ",
  "Not working": "لا يعمل",
  "Checked": "المراجعة",
  "Back to today": "العودة إلى اليوم",
  "people": "موظفين",
  "Give an advance": "صرف سلفة",
  "Pay people": "صرف الرواتب",
  "Everyone starts as working, so on a normal day it's one tap.": "يبدأ الجميع بحالة يعمل، لذا يكفي الحفظ في اليوم المعتاد.",
  "＋ Someone new started": "＋ بدأ موظف جديد العمل",
  "e.g. came in late, left early": "مثلًا: جاء متأخرًا، انصرف مبكرًا",
  "e.g. He came in the evening, I marked him by mistake": "مثلًا: جاء في المساء وسجّلته غائبًا بالخطأ",
  "You're changing a past day. Your name, the time and your reason are saved with it.": "أنت تعدّل يومًا سابقًا. يُحفظ معه اسمك والوقت والسبب.",
  "Nobody checked the team that day. Fill it in now; it is saved as filled in later, with your name.": "لم يراجع أحد الفريق في هذا اليوم. أكمله الآن، وسيُحفظ على أنه أُكمل لاحقًا باسمك.",
  "Pick any day to see it or change it. Changes to past days need a reason and are logged.": "اختر أي يوم لعرضه أو تعديله. تعديل الأيام السابقة يتطلب سببًا ويُسجَّل.",
};

export function attendanceText(en: string, fallback: string, rtl: boolean): string {
  if (!rtl) return en;
  if (approved[en]) return approved[en];
  const translated = staffText(en, true);
  return translated !== en ? translated : fallback;
}

const attendanceRefusals:Record<string,string>={
  "Branch access denied":"لا تملك صلاحية الوصول إلى هذا الفرع.",
  "Branch not found":"لم يُعثر على هذا الفرع.",
  "Attendance access required":"لا تملك صلاحية عرض الحضور.",
  "Attendance save permission required":"لا تملك صلاحية حفظ الحضور.",
  "This day cannot be changed":"لا يمكن تعديل حضور هذا اليوم؛ التاريخ خارج المدة المسموح لك بتعديلها أو يقع في المستقبل.",
  "A reason is required for a past day":"يجب إدخال سبب لتعديل يوم حضور سابق.",
  "Correct the saved days instead of resetting an absence counter":"صحّح أيام الحضور المحفوظة بدلًا من إعادة تعيين عدّاد الغياب.",
  "The team changed. Refresh and check everyone.":"تغيّر فريق الفرع. حدّث البيانات وراجع حضور جميع الموظفين.",
  "Unknown or inactive shift":"الوردية المحددة غير معروفة أو غير نشطة.",
  "Review the late sick report before changing its status.":"راجع بلاغ المرض المتأخر قبل تغيير حالته.",
  "Late sick decision permission required":"لا تملك صلاحية البت في بلاغ المرض المتأخر.",
  "Only Finance or an administrator can change the attendance day end":"يمكن للمسؤول والشؤون المالية فقط تعديل وقت انتهاء يوم الحضور.",
  "Workspace role required":"يلزم وجود دور صالح في مساحة العمل الحالية.",
  "Staff access required":"لا تملك صلاحية الوصول إلى بيانات الموظفين.",
  "Invalid day":"تاريخ الحضور غير صالح.",
  "Invalid":"القيمة المدخلة غير صالحة.",
  "Duplicate people":"لا يمكن تكرار الموظف في سجل الحضور.",
  "Duplicate shifts":"لا يمكن تكرار الوردية للموظف نفسه.",
  "Attendance day ends at must be between 00:00 and 08:00":"يجب أن يكون وقت انتهاء يوم الحضور بين 00:00 و08:00.",
};

/** Translate known refusals precisely; retain details for unknown validations. */
export function attendanceErrorText(error:unknown,rtl:boolean):string {
  const message=error instanceof Error?error.message:String(error||"");
  if(!rtl||/[\u0600-\u06ff]/.test(message))return message;
  const code=error&&typeof error==="object"&&"code" in error?error.code:undefined;
  if(code==="ATTENDANCE_PAST_DAY_REASON_REQUIRED")return attendanceRefusals["A reason is required for a past day"];
  if(attendanceRefusals[message])return attendanceRefusals[message];
  const limit=message.match(/^(String|Array) must contain at (most|least) (\d+) (character|element)\(s\)$/);
  if(limit)return `${limit[1]==="String"?"يجب أن يحتوي النص":"يجب أن تحتوي القائمة"} على ${limit[3]} ${limit[1]==="String"?"حرفًا":"عنصرًا"} ${limit[2]==="most"?"كحد أقصى":"على الأقل"}.`;
  if(/^Required$|^Invalid input: expected |^Expected .+, received |^Invalid enum value\./i.test(message))return "قيمة مطلوبة مفقودة أو غير صالحة. راجع تاريخ الحضور وحالات الموظفين والورديات.";
  if(/network|fetch|connection|offline/i.test(message))return "تعذّر الاتصال بالخادم. تحقق من الاتصال ثم أعد المحاولة.";
  return message?`تعذّر حفظ بيانات الحضور. سبب الرفض من الخادم: ${message}`:"تعذّر حفظ بيانات الحضور. أعد المحاولة.";
}

export function attendanceClock(value?: string | null): string {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
}
